import { type LeadNote } from '@app/queries/notes/leadNoteList';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface NotesState {
  isModalOpen: boolean;
  editNote?: LeadNote;
  mode: 'create' | 'edit';
}

const initialState: NotesState = {
  isModalOpen: false,
  mode: 'create',
};

export const notesSlice = createSlice({
  name: 'notesTab',
  initialState,
  reducers: {
    setIsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setEditNoteMode: (state, action: PayloadAction<'create' | 'edit'>) => {
      state.mode = action.payload;
    },
    setEditNote: (state, action: PayloadAction<LeadNote | undefined>) => {
      state.editNote = action.payload;
    },
  },
});

export const {
  setIsModalOpen,
  setEditNote,
  setEditNoteMode,
} = notesSlice.actions;

export default notesSlice.reducer;
